import React from 'react';
// template components
import InformationalModule from '@nmx/template/dist/componentLibrary/modules/InformationalModule';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImageDesktopWebp from './images/happy-couple-walking-on-the-sidewalk.webp';
import financialPlanningImageMobileWebp from './images/happy-couple-walking-on-the-sidewalk-mobile.webp';
// styles
import { BulletedListStyled } from './styles';

export default () => {
  return (
    <InformationalModule
      // configs
      sectionId='investments-financial-planning-2'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent
      // content
      subHeadingText={<>The key to a strong financial plan&#63; <WidowBlock>Investment solutions.</WidowBlock></>}
      // column content
      columnContentA={(
        <>
          <Typography nextElement='typography'>
            At Northwestern Mutual, we see investments as just one part of your bigger financial plan. You&#39;ll have access to more financial options designed to reinforce each other so your plan can work its hardest for you like investments for growth, insurance for protection and guaranteed growth, and annuities for more flexibility in retirement. Once your advisor looks at every aspect of your financial life and listens to your goals, they&#39;ll tailor your plan to help you:
          </Typography>
          <BulletedListStyled
            bulletType='checkmark'
            disableBottomPadding
            bulletedListData={[
              { bulletText: 'Grow your money with the right investments for today and down the road' },
              { bulletText: 'Make the most of what you have with recommendations for saving and paying down debt' },
              { bulletText: (<>Protect everything you&#39;ve worked so hard for</>) },
            ]}
          />
          <Link
            id='investments-financial-planning-2-section-watch-video'
            variant='buttonLinkPrimary'
            themeType='lightTheme'
            linkUrl='/financial-planning/'>
            Our approach to planning
          </Link>
        </>
      )}
      // image props
      imageAltText='A happy couple walking on a sidewalk.'
      imageSrcDefault={financialPlanningImageDesktopWebp}
      imageSrcMobile={financialPlanningImageMobileWebp}
    />
  );
};
